import { cn } from '@zealot/ui/lib/utils';
import type * as React from 'react';

// gloss
const IndicatorDot = ({ className, ...props }: React.ComponentProps<'span'>) => (
  <span
    aria-hidden="true"
    data-slot="indicator-dot"
    className={cn('absolute -top-0.5 -right-0.5 size-2 rounded-full bg-primary ring-2 ring-background', className)}
    {...props}
  />
);

export { IndicatorDot };
